import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import CalendarioAgenda from './CalendarioAgenda';
import { COR, FONTE } from './ui';

// =====================================================================
// BOTÃO DA AGENDA — ícone de calendário no cabeçalho + modal do calendário
// =====================================================================
// Vive ao lado do sino e do manual, nas TRÊS barras superiores do portal:
// a da Home (desktop e mobile) e a dos módulos (ModuloHeader).
//
// Por que existe: a Agenda Corporativa era um card exclusivo da Home, e ainda
// por cima só na "home genérica" — os perfis de gestão (Admin, Gerente,
// Diretoria, Gerente Plantão) caem no Dashboard de Operação e NUNCA viam a
// agenda. Pelo cabeçalho ela fica a um clique de qualquer tela, para qualquer
// perfil. O card da home genérica continua onde estava (quem já usava assim não
// perde nada) — este botão é um caminho a mais, não um substituto.
//
// O componente é AUTOSSUFICIENTE de propósito: importa a paleta do ./ui direto,
// então quem monta só precisa passar a cor do ícone. Isso é o que permite o
// ModuloHeader (que não conhece os tokens da Home) usá-lo sem cerimônia.
//
// LAZY: o <CalendarioAgenda> só é montado com o modal ABERTO — fechado, o ícone
// não custa nenhuma chamada (nem ao Graph, nem às camadas internas). É por isso
// que o modal é montado condicionalmente em vez de ficar escondido com display:none.
//
// Props:
//   - cor          : cor do ícone (amarelo na Home, cor do módulo no header)
//   - tamanhoIcone : tamanho do ícone (24 desktop, 22 mobile)

function BotaoAgenda({ cor = COR.vermelhoEscuro, tamanhoIcone = 24 }) {
    const [aberto, setAberto] = useState(false);

    // Esc fecha o modal (atalho esperado de qualquer modal).
    useEffect(() => {
        if (!aberto) return;
        const aoTeclar = (e) => { if (e.key === 'Escape') setAberto(false); };
        document.addEventListener('keydown', aoTeclar);
        return () => document.removeEventListener('keydown', aoTeclar);
    }, [aberto]);

    return (
        <>
            <button
                onClick={() => setAberto(true)}
                title="Agenda Corporativa"
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: cor, display: 'flex', alignItems: 'center', padding: '6px' }}
            >
                <Calendar size={tamanhoIcone} />
            </button>

            {aberto && (
                <div
                    onClick={(e) => { if (e.target === e.currentTarget) setAberto(false); }}
                    style={{
                        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        padding: '20px', fontFamily: FONTE,
                        // Abaixo do 1000 do FormCompromisso, que é aberto DE DENTRO
                        // deste modal e precisa empilhar por cima dele.
                        zIndex: 950,
                    }}
                >
                    {/* Largo o bastante para 7 colunas legíveis — um grid de mês não
                        cabe na largura de modal de formulário. */}
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: '#fff', borderRadius: '14px', padding: '20px',
                            width: '100%', maxWidth: '1040px', maxHeight: '92vh',
                            display: 'flex', flexDirection: 'column', boxSizing: 'border-box',
                        }}
                    >
                        <CalendarioAgenda onFechar={() => setAberto(false)} />
                    </div>
                </div>
            )}
        </>
    );
}

export default BotaoAgenda;
